export default {
    lightTheme: {
        colors: {
            background: 'radial-gradient(grey, black)', // Don't know why it was lightGrey by default
            black: 'black',
            white: 'white',
            blue: '#a0e9fd',
            lightBlue: '#caf3fe',
            secondary: 'radial-gradient(green, yellow)',
        },
        transition: '0.3s',
    },
    darkTheme: {
        colors: {
            background: 'radial-gradient(black, grey)', // Don't know why it was lightGrey by default
            black: 'white',
            white: 'black',
            blue: '#a0e9fd',
            lightBlue: '#caf3fe',
            secondary: 'radial-gradient(yellow, green)',
        },
        transition: '0.3s',
    },
}